import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { connect } from "react-redux";

// Redirect Utility
import AuthRedirectRoute from "../../utils/AuthRedirectRoute";
import LoginRedirectRoute from "../../utils/LoginRedirectRoute";

//Pages
import LandingPage from "../../pages/landingpage/landingPage";
import Login from "../../pages/login/login";
import Profilepage from "../../pages/profilepage/profilepage";
import Signup from "../../pages/signup/signup";
import DocumentUpload from "../../pages/documentUpload/DocumentUpload";
import Settings from "../../pages/settings/settings";
import ProjectShowcase from "../../pages/projectShowcase/projectShowcase";
import EventFeeds from "../../pages/eventFeeds/eventFeeds";

//Components
import Sidebar from "../sidebar/Sidebar";
import Dashboard from "./Dashboard";
import EntryPages from "./EntryPages";
import NoMatchPage from "../noMatchFound/NoMatchPage";

//Styles
import styles from "./layout.module.css";
import VerificationMessage from "../../pages/verificationMessage/VerificationMessage";
import EmailVerification from "../../pages/emailVerification/emailVerification";
import SearchPage from "../../pages/searchPage/searchPage";

class Layout extends Component {
    render() {
        return (
            <div>
                <Router>
                    <Switch>
                        <LoginRedirectRoute
                            exact
                            path="/login"
                            component={(props) => (
                                <EntryPages name="Login" backButton={true}>
                                    <Login
                                        history={props.history}
                                        location={props.location}
                                        match={props.match}
                                    />
                                </EntryPages>
                            )}
                        />
                        <LoginRedirectRoute
                            exact
                            path="/signup"
                            component={(props) => (
                                <EntryPages name="Signup" backButton={true}>
                                    <Signup
                                        history={props.history}
                                        location={props.location}
                                        match={props.match}
                                    />
                                </EntryPages>
                            )}
                        />

                        <LoginRedirectRoute
                            exact
                            path="/signup/document"
                            component={(props) => (
                                <EntryPages
                                    name="Document Upload"
                                    backButton={true}
                                >
                                    <DocumentUpload
                                        history={props.history}
                                        location={props.location}
                                        match={props.match}
                                    />
                                </EntryPages>
                            )}
                        />

                        <LoginRedirectRoute
                            exact
                            path="/signup/verification"
                            component={(props) => (
                                <EntryPages
                                    name="Verification"
                                    backButton={false}
                                >
                                    <VerificationMessage
                                        history={props.history}
                                        location={props.location}
                                        match={props.match}
                                    />
                                </EntryPages>
                            )}
                        />

                        <Route
                            exact
                            path="/"
                            component={(props) => (
                                <LandingPage
                                    history={props.history}
                                    location={props.location}
                                    match={props.match}
                                />
                            )}
                        />

                        <Route
                            exact
                            path="/email/verify/:emailJwtToken"
                            component={(props) => (
                                <EmailVerification
                                    history={props.history}
                                    location={props.location}
                                    match={props.match}
                                />
                            )}
                        />

                        <Dashboard>
                            <Route
                                component={(props) => (
                                    <div className={styles.container}>
                                        <Sidebar />
                                        <div className={styles.mainContainer}>
                                            <Switch>
                                                <AuthRedirectRoute
                                                    exact
                                                    path="/dashboard/profile"
                                                    component={Profilepage}
                                                />
                                                <AuthRedirectRoute
                                                    exact
                                                    path="/dashboard/settings"
                                                    component={Settings}
                                                />
                                                <AuthRedirectRoute
                                                    exact
                                                    path="/dashboard/projectShowcase"
                                                    component={ProjectShowcase}
                                                />
                                                <AuthRedirectRoute
                                                    exact
                                                    path="/dashboard/eventFeeds"
                                                    component={EventFeeds}
                                                />
                                                <AuthRedirectRoute
                                                    exact
                                                    path="/dashboard/search"
                                                    component={SearchPage}
                                                />
                                                <AuthRedirectRoute
                                                    component={NoMatchPage}
                                                />
                                            </Switch>
                                        </div>
                                    </div>
                                )}
                            />
                        </Dashboard>
                        <Route component={NoMatchPage} />
                    </Switch>
                </Router>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(Layout);
